import Common from '@/utilities/Common';
import moment from "moment";

export class QuestelServicesConstants {

  public static EuropeanPatentOffice: string = "480A650D-0BCD-41EA-8BF9-7D8E950D8922";

  public static allowedFileTypes: Array<string> = [
    "application/pdf", // PDF
    "application/rtf", // RTF
    "application/msword", // word
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // word
    "application/vnd.ms-excel", // excel
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // excel
    "application/vnd.ms-powerpoint", // powerpoint
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // powerpoint
    "application/vnd.visio", // visio
    "application/vnd.ms-visio.viewer", //visio
    "application/vnd.visio.xml", //visio
    "application/x-zip-compressed", // ZIP
    "image/bmp", // BMP
    "image/jpeg", // JPEG
    "image/png", // PNG
    "image/tiff", // TIFF
    "text/plain", // TXT
    "text/csv", // CSV
  ];

  public static allowedFileExtensions: Array<string> = [".hlt", ".csv", ".vsd", ".vsdx"];

    public static validationRules: {
      required: (value: any) => boolean | string,
      minNumber: (value: any) => boolean | string,
      minValue: (minValue: number) => (value: any) => boolean | string,
      integer: (value: any) => boolean | string,
      positiveNumber: (value: any) => boolean | string,
      minLength: (minLength: number) => (value: any) => boolean | string,
      maxLength: (maxLength: number) => (value: any) => boolean | string,
      emailList: (values: any) => boolean | string,
      emailFormat: (values: any) => boolean | string,
      arrayRequired: (value : any[]) => boolean | string,
      uniqueEmails: (values: any) => boolean | string,
      invalidFileNameCharacters: (value: string) => boolean | string,
      minimumDate: (minDate: any) => (value: any) => boolean | string
    } = {
      required: v =>  ((typeof(v) == "number") ? !!(v.toString()) : !!v) || "This field is required",
      minNumber: v => v >= 0 || "Minimum value is 0",
      minValue: (minValue: number = 0) => v => v >= minValue || `Minimum value is ${minValue}`,
      integer: value =>  !value || (!!value && !isNaN(parseFloat(value)) && Number.isInteger(parseFloat(value))) || "This field must be a whole number",
      positiveNumber: value =>  !value || (!!value && !isNaN(parseFloat(value)) && parseFloat(value) >= 0) || "This field must be a positive number",
      minLength: (minLength: number = 0) => v => (!!v && v.toString().length >= minLength) || `Minimum length is ${minLength} characters`,
      maxLength: (maxLength: number = 0) => v => (!Common.hasValue(v) || (!!v && v.toString().length <= maxLength)) || `Maximum length is ${maxLength} characters`,
      emailList: (values: string[]) => !values || !Array.isArray(values) || (!!values && values.length === 0) || (!!values && values.every(value => QuestelServicesConstants.emailFormat.test(value))) || 'One or more email addresses have an invalid format',
      emailFormat: (value: string) => !value || (!!value && QuestelServicesConstants.emailFormat.test(value)) || 'Email address has an invalid format',
      arrayRequired: (value) => (!!value && value.length > 0) || "At least one selection is required.",
      uniqueEmails: (values: string[]) => {
        values = values.map(v => v.toLocaleLowerCase());
        return !values || !Array.isArray(values) || (!!values && values.length === 0) || (!!values && (new Set(values).size === values.length)) || 'One or more email addresses already exist'
      },
      invalidFileNameCharacters: (value) => !value || (!!value && !QuestelServicesConstants.invalidFileNameCharacters.test(value)) || 'This field cannot contain any of the following characters: \\ : ? " < > |',
      minimumDate: (minDate: any) => v => moment(v, 'DD-MMM-YYYY').isSameOrAfter(moment(minDate, 'YYYY-MM-DD')) || `Minimum date is ${moment(minDate).format('DD-MMM-YYYY')}`
    };

  // Regular expression for email format used in Savanta
  public static emailFormat: RegExp =/^(([a-zA-Z0-9&_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*(;)\s*|\s*$))+$/;

  // Invalid windows folder name characters
  public static invalidFileNameCharacters: RegExp = /[\\:?"<>|]+/;

  //default date format for all pages
  public static defaultDateFormat: string = "DD-MMM-YYYY";
  public static defaultEnglish: string = "en-US";
}
